import {
    TenantAssessmentAuthenticatedLayout,
    type TenantAssessmentAuthenticatedLayoutProps
} from "./TenantAssessmentAuthenticatedLayout.tsx";

/**
 * The layouts are used as component type, so we can't pass properties
 * This is why we created this component that basically feeds isFullScreen to the authenticated layout
 */
export const FullScreenTenantAssessmentAuthenticatedLayout = (
    props: Omit<TenantAssessmentAuthenticatedLayoutProps, "isFullScreen">
) => <TenantAssessmentAuthenticatedLayout {...props} isFullScreen />;
